/**
 * @providesModule Slugger
 */
import React from 'react';
import { View } from 'react-native';
import { OP_NEXT_DRAWFRAME, schedulers } from './schedule';

const UPDATE_PROPS_PENDING_UPDATE = 1;
const UPDATE_COMMITIED = 2;

export default class AsyncSlugger extends React.Component {
    updateState;

    constructor(props) {
        super(props);
        this.state = {};
        const { target } = props;
        if (target) {
            this.displayName =
                target.displayName || target.constructor.displayName || target.constructor.name;
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps, nextContext) {
        this.updateState = UPDATE_PROPS_PENDING_UPDATE;
        const commit = schedulers[nextProps.schedule || OP_NEXT_DRAWFRAME];
        commit(() => {
            if (this.willUnmount) {
                return;
            }
            this.updateState = UPDATE_COMMITIED;
            this.setState({
                childrenProps: nextProps,
            });
        });
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (this.updateState === UPDATE_PROPS_PENDING_UPDATE) {
            return false;
        }
        return true;
    }

    componentDidMount() {
        setTimeout(()=>{
            this.setState({ didMount: true });
        },0);
    }

    componentWillUnMount() {
        this.willUnmount = true;
    }

    render() {
        const { target: Target, placeholder } = this.props;
        if (!this.state.didMount) {
            return placeholder ? <View style={placeholder} /> : null;
        }
        return <Target {...this.props} />;
    }
}
